export const orderData = [
  {
    id: '3413',
    name: 'Dr. Ernest Fritsch-Shanahan',
    email: 'August17@hotmail.com',
    avatar:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-15.webp',
    items: 83,
    price: '457.00',
    status: 'Cancelled',
    createdAt: '2023-08-06T00:01:51.735Z',
    updatedAt: '2023-08-10T22:39:21.113Z',
    products: [
      {
        id: '0o02051402',
        name: 'Tasty Metal Shirt',
        category: 'Shoes',
        image:
          'https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/7.webp',
        price: '410.00',
        quantity: 2,
      },
      {
        id: '0o17477064',
        name: 'Modern Cotton Gloves',
        category: 'Watch',
        image:
          'https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/5.webp',
        price: '342.00',
        quantity: 3,
      },
      {
        id: '0o02374305',
        name: 'Rustic Steel Computer',
        category: 'Shoes',
        image:
          'https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/6.webp',
        price: '948.00',
        quantity: 1,
      },
    ],
  },
  {
    id: '9192',
    name: 'Mr. Gregory Medhurst-Lubowitz',
    email: 'General.Bergstrom@yahoo.com',
    avatar:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-14.webp',
    items: 21,
    price: '426.00',
    status: 'Cancelled',
    createdAt: '2023-07-22T10:53:43.612Z',
    updatedAt: '2023-08-13T08:39:41.230Z',
    products: [
      {
        id: '0o02602714',
        name: 'Licensed Concrete Cheese',
        category: 'Shirt',
        image:
          'https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/7.webp',
        price: '410.00',
        quantity: 2,
      },
      {
        id: '0o24033230',
        name: 'Gorgeous Bronze Gloves',
        category: 'Watch',
        image:
          'https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/1.webp',
        price: '948.00',
        quantity: 1,
      },
    ],
  },
  {
    id: '4983',
    name: 'Becky Goodwin',
    email: 'Daniella_Littel@gmail.com',
    avatar:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-13.webp',
    items: 93,
    price: '544.00',
    status: 'Refunded',
    createdAt: '2023-07-29T08:46:59.211Z',
    updatedAt: '2023-08-08T22:08:04.564Z',
    products: [
      {
        id: '0o02374305',
        name: 'Rustic Steel Computer',
        category: 'Shoes',
        image:
          'https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/2.webp',
        price: '948.00',
        quantity: 1,
      },
    ],
  },
  {
    id: '9114',
    name: 'Mrs. Ann Leuschke Jr.',
    email: 'Favian49@yahoo.com',
    avatar:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-12.webp',
    items: 63,
    price: '282.00',
    status: 'Cancelled',
    createdAt: '2023-07-25T20:22:56.250Z',
    updatedAt: '2023-08-12T00:03:41.358Z',
    products: [
      {
        id: '0o02051402',
        name: 'Tasty Metal Shirt',
        category: 'Shoes',
        image:
          'https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/4.webp',
        price: '410.00',
        quantity: 2,
      },
      {
        id: '0o17477064',
        name: 'Modern Cotton Gloves',
        category: 'Watch',
        image:
          'https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/5.webp',
        price: '342.00',
        quantity: 3,
      },
      {
        id: '0o02374305',
        name: 'Rustic Steel Computer',
        category: 'Shoes',
        image:
          'https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/6.webp',
        price: '948.00',
        quantity: 1,
      },
    ],
  },
  {
    id: '4849',
    name: 'Elmer Heathcote',
    email: 'Efren.Wehner@gmail.com',
    avatar:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-11.webp',
    items: 89,
    price: '971.00',
    status: 'Refunded',
    createdAt: '2023-07-18T14:45:23.679Z',
    updatedAt: '2023-08-14T10:42:39.616Z',
    products: [
      {
        id: '0o02051402',
        name: 'Tasty Metal Shirt',
        category: 'Shoes',
        image:
          'https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/4.webp',
        price: '410.00',
        quantity: 2,
      },
    ],
  },
  {
    id: '8540',
    name: 'Ida McKenzie',
    email: 'Waino_Bosco@hotmail.com',
    avatar:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-10.webp',
    items: 64,
    price: '889.00',
    status: 'Cancelled',
    createdAt: '2023-07-20T08:05:40.492Z',
    updatedAt: '2023-08-13T05:34:50.038Z',
    products: [
      {
        id: '0o17477064',
        name: 'Modern Cotton Gloves',
        category: 'Watch',
        image:
          'https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/5.webp',
        price: '342.00',
        quantity: 3,
      },
      {
        id: '0o02374305',
        name: 'Rustic Steel Computer',
        category: 'Shoes',
        image:
          'https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/6.webp',
        price: '948.00',
        quantity: 1,
      },
    ],
  },
  {
    id: '3114',
    name: 'Randal Dare',
    email: 'Morton_Lubowitz@hotmail.com',
    avatar:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-09.webp',
    items: 23,
    price: '566.00',
    status: 'Cancelled',
    createdAt: '2023-06-25T08:19:38.694Z',
    updatedAt: '2023-08-11T10:48:02.311Z',
    products: [
      {
        id: '0o02051402',
        name: 'Tasty Metal Shirt',
        category: 'Shoes',
        image:
          'https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/4.webp',
        price: '410.00',
        quantity: 2,
      },
      {
        id: '0o17477064',
        name: 'Modern Cotton Gloves',
        category: 'Watch',
        image:
          'https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/5.webp',
        price: '342.00',
        quantity: 3,
      },
      {
        id: '0o02374305',
        name: 'Rustic Steel Computer',
        category: 'Shoes',
        image:
          'https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/6.webp',
        price: '948.00',
        quantity: 1,
      },
    ],
  },
  {
    id: '3174',
    name: 'Jesse Zboncak',
    email: 'Kurtis6@yahoo.com',
    avatar:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-08.webp',
    items: 43,
    price: '999.00',
    status: 'Completed',
    createdAt: '2023-08-07T21:17:12.562Z',
    updatedAt: '2023-08-08T19:18:27.856Z',
    products: [
      {
        id: '0o17477064',
        name: 'Modern Cotton Gloves',
        category: 'Watch',
        image:
          'https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/5.webp',
        price: '342.00',
        quantity: 3,
      },
      {
        id: '0o02374305',
        name: 'Rustic Steel Computer',
        category: 'Shoes',
        image:
          'https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/6.webp',
        price: '948.00',
        quantity: 1,
      },
    ],
  },
  {
    id: '6554',
    name: 'Tom Turcotte',
    email: 'Myrl.Reilly@gmail.com',
    avatar:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-07.webp',
    items: 37,
    price: '130.00',
    status: 'Pending',
    createdAt: '2023-07-27T23:26:42.282Z',
    updatedAt: '2023-08-13T11:09:17.221Z',
    products: [
      {
        id: '0o02051402',
        name: 'Tasty Metal Shirt',
        category: 'Shoes',
        image:
          'https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/7.webp',
        price: '410.00',
        quantity: 2,
      },
    ],
  },
  {
    id: '0828',
    name: 'Horace McGlynn',
    email: 'Dulce_Williamson37@yahoo.com',
    avatar:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-06.webp',
    items: 35,
    price: '224.00',
    status: 'Completed',
    createdAt: '2023-06-23T05:07:35.289Z',
    updatedAt: '2023-08-11T13:11:46.567Z',
    products: [
      {
        id: '0o02051402',
        name: 'Tasty Metal Shirt',
        category: 'Shoes',
        image:
          'https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/7.webp',
        price: '410.00',
        quantity: 2,
      },
      {
        id: '0o02374305',
        name: 'Rustic Steel Computer',
        category: 'Shoes',
        image:
          'https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/6.webp',
        price: '948.00',
        quantity: 1,
      },
    ],
  },
  {
    id: '0652',
    name: 'Michelle Hackett',
    email: 'Leila48@yahoo.com',
    avatar:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-05.webp',
    items: 40,
    price: '822.00',
    status: 'Pending',
    createdAt: '2023-06-22T14:46:16.261Z',
    updatedAt: '2023-08-14T09:26:54.379Z',
    products: [
      {
        id: '0o02051402',
        name: 'Tasty Metal Shirt',
        category: 'Shoes',
        image:
          'https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/7.webp',
        price: '410.00',
        quantity: 2,
      },
      {
        id: '0o17477064',
        name: 'Modern Cotton Gloves',
        category: 'Watch',
        image:
          'https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/5.webp',
        price: '342.00',
        quantity: 3,
      },
    ],
  },
  {
    id: '9026',
    name: 'Luther Windler',
    email: 'Carmella.Morar52@gmail.com',
    avatar:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-04.webp',
    items: 75,
    price: '746.00',
    status: 'Completed',
    createdAt: '2023-07-20T22:17:58.082Z',
    updatedAt: '2023-08-11T16:33:59.353Z',
    products: [
      {
        id: '0o02051402',
        name: 'Tasty Metal Shirt',
        category: 'Shoes',
        image:
          'https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/7.webp',
        price: '410.00',
        quantity: 2,
      },
      {
        id: '0o17477064',
        name: 'Modern Cotton Gloves',
        category: 'Watch',
        image:
          'https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/5.webp',
        price: '342.00',
        quantity: 3,
      },
      {
        id: '0o02374305',
        name: 'Rustic Steel Computer',
        category: 'Shoes',
        image:
          'https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/6.webp',
        price: '948.00',
        quantity: 1,
      },
    ],
  },
  {
    id: '0895',
    name: 'Hazel Wuckert',
    email: 'Breanna.Stanton@gmail.com',
    avatar:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-03.webp',
    items: 12,
    price: '274.00',
    status: 'Pending',
    createdAt: '2023-07-18T18:12:30.382Z',
    updatedAt: '2023-08-14T09:01:30.112Z',
    products: [
      {
        id: '0o02374305',
        name: 'Rustic Steel Computer',
        category: 'Shoes',
        image:
          'https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/6.webp',
        price: '948.00',
        quantity: 1,
      },
    ],
  },
  {
    id: '6322',
    name: 'Joanne Batz',
    email: 'Izabella44@gmail.com',
    avatar:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-02.webp',
    items: 93,
    price: '202.00',
    status: 'Refunded',
    createdAt: '2023-08-10T14:10:56.495Z',
    updatedAt: '2023-08-07T12:18:04.534Z',
    products: [
      {
        id: '0o02051402',
        name: 'Tasty Metal Shirt',
        category: 'Shoes',
        image:
          'https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/7.webp',
        price: '410.00',
        quantity: 2,
      },
      {
        id: '0o02374305',
        name: 'Rustic Steel Computer',
        category: 'Shoes',
        image:
          'https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/6.webp',
        price: '948.00',
        quantity: 1,
      },
    ],
  },
  {
    id: '8216',
    name: 'Kara Goodwin',
    email: 'Milford67@gmail.com',
    avatar:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-01.webp',
    items: 57,
    price: '329.00',
    status: 'Pending',
    createdAt: '2023-06-25T13:48:55.907Z',
    updatedAt: '2023-08-12T11:04:54.639Z',
    products: [
      {
        id: '0o17477064',
        name: 'Modern Cotton Gloves',
        category: 'Watch',
        image:
          'https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/5.webp',
        price: '342.00',
        quantity: 3,
      },
      {
        id: '0o02374305',
        name: 'Rustic Steel Computer',
        category: 'Shoes',
        image:
          'https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/6.webp',
        price: '948.00',
        quantity: 1,
      },
    ],
  },
  {
    id: '5881',
    name: 'Mr. Irvin Farrell',
    email: 'Chanel21@yahoo.com',
    avatar:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-15.webp',
    items: 91,
    price: '263.00',
    status: 'Pending',
    createdAt: '2023-07-10T17:48:56.737Z',
    updatedAt: '2023-08-13T06:10:40.908Z',
    products: [
      {
        id: '0o17477064',
        name: 'Modern Cotton Gloves',
        category: 'Watch',
        image:
          'https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/5.webp',
        price: '342.00',
        quantity: 3,
      },
    ],
  },
  {
    id: '9850',
    name: 'Seth Rau',
    email: 'Bartholome24@gmail.com',
    avatar:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-14.webp',
    items: 88,
    price: '808.00',
    status: 'Completed',
    createdAt: '2023-07-19T13:36:32.739Z',
    updatedAt: '2023-08-11T17:35:20.683Z',
    products: [
      {
        id: '0o02051402',
        name: 'Tasty Metal Shirt',
        category: 'Shoes',
        image:
          'https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/7.webp',
        price: '410.00',
        quantity: 2,
      },
      {
        id: '0o17477064',
        name: 'Modern Cotton Gloves',
        category: 'Watch',
        image:
          'https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/5.webp',
        price: '342.00',
        quantity: 3,
      },
      {
        id: '0o02374305',
        name: 'Rustic Steel Computer',
        category: 'Shoes',
        image:
          'https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/6.webp',
        price: '948.00',
        quantity: 1,
      },
    ],
  },
];
